import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/style.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));

if (process.env.NODE_ENV !== "development") {
    console.log = function() {};
    console.debug =function() {};
    console.info = function() {};
    console.warn = function() {};
   console.error = function() {};
}

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
